import Typography from "../Typography/Typography";
import styles from "./Select.module.scss";

const Select = (props) => {
	const {
		className,
		label = "",
		placeholder = "",
		options = [],
		onChange = () => null,
		error = false,
		center = false,
		setError = () => null,
	} = props;

	return (
		<div className={`${styles.selectContainer} ${className}`}>
			<Typography bold variant="h6">
				{label}
			</Typography>
			<select
				className={`${styles.select} ${error && styles.selectError} ${
					center && styles.selectCenter
				}`}
				onChange={(e) => {
					if (e.target.value === placeholder) onChange(null);
					else onChange(e.target.value);
				}}
				onFocus={() => {
					setError(false);
				}}
			>
				<option>{placeholder}</option>
				{options.map((o, i) => (
					<option key={o + i}>{o}</option>
				))}
			</select>
		</div>
	);
};

export default Select;
